// Mobile menu functionality
import { schoolsData, onCityChange } from "./schools-system"

let currentMobileSchoolIndex = 0
let mobileAutoRotateInterval = null
const MOBILE_ROTATE_INTERVAL = 5000

export function initMobileMenu() {
  const burger = document.querySelector(".header__burger")
  const mobileMenu = document.querySelector(".header__mobile-menu")
  const closeBtn = document.querySelector(".header__mobile-close")
  const overlay = document.querySelector(".header__mobile-overlay")

  if (!burger || !mobileMenu) return

  // Open menu
  burger.addEventListener("click", () => {
    openMobileMenu()
  })

  // Close menu
  if (closeBtn) {
    closeBtn.addEventListener("click", closeMobileMenu)
  }

  if (overlay) {
    overlay.addEventListener("click", closeMobileMenu)
  }

  // Initialize mobile city selector
  initMobileCitySelector()

  // Initialize mobile submenu toggles
  initMobileSubmenus()

  // Initialize mobile schools slider
  initMobileSchoolsSlider()

  // Close on escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && mobileMenu.classList.contains("active")) {
      closeMobileMenu()
    }
  })
}

function openMobileMenu() {
  const burger = document.querySelector(".header__burger")
  const mobileMenu = document.querySelector(".header__mobile-menu")

  burger.classList.add("active")
  mobileMenu.classList.add("active")
  document.body.classList.add("no-scroll")

  // Start mobile schools rotation
  startMobileSchoolsRotation()
}

function closeMobileMenu() {
  const burger = document.querySelector(".header__burger")
  const mobileMenu = document.querySelector(".header__mobile-menu")

  burger.classList.remove("active")
  mobileMenu.classList.remove("active")
  document.body.classList.remove("no-scroll")

  // Stop mobile schools rotation
  stopMobileSchoolsRotation()

  // Close all submenus
  document.querySelectorAll(".header__mobile-menu-item--open").forEach((item) => {
    item.classList.remove("header__mobile-menu-item--open")
  })
}

function initMobileCitySelector() {
  const cityBtn = document.querySelector(".header__mobile-city-btn")
  const cityDropdown = document.querySelector(".header__mobile-city-dropdown")
  const cityInput = document.querySelector(".header__mobile-city-input")
  const cityList = document.querySelector(".header__mobile-city-list")
  const currentCityEl = document.querySelector(".header__mobile-current-city")

  if (!cityBtn || !cityDropdown) return

  // Populate city list
  const cities = Object.keys(schoolsData)
  if (cityList) {
    cityList.innerHTML = cities
      .map(
        (city) => `
      <button class="header__mobile-city-option ${city === "Екатеринбург" ? "header__mobile-city-option active" : ""}" data-city="${city}">
        ${city}
        <span class="header__mobile-city-schools-count">${schoolsData[city].length} ${getSchoolsWord(schoolsData[city].length)}</span>
      </button>
    `,
      )
      .join("")
  }

  // Toggle dropdown
  cityBtn.addEventListener("click", () => {
    cityDropdown.classList.toggle("active")
    cityBtn.classList.toggle("active")
    if (cityInput) setTimeout(() => cityInput.focus(), 100)
  })

  // Filter cities
  if (cityInput) {
    cityInput.addEventListener("input", (e) => {
      const searchTerm = e.target.value.toLowerCase()
      document.querySelectorAll(".header__mobile-city-option").forEach((option) => {
        const cityName = option.dataset.city.toLowerCase()
        option.style.display = cityName.includes(searchTerm) ? "" : "none"
      })
    })
  }

  // Select city
  cityList?.addEventListener("click", (e) => {
    const option = e.target.closest(".header__mobile-city-option")
    if (!option) return

    const city = option.dataset.city

    // Update active state
    document.querySelectorAll(".header__mobile-city-option").forEach((opt) => {
      opt.classList.remove("active")
    })
    option.classList.add("active")

    // Update current city display
    if (currentCityEl) currentCityEl.textContent = city

    // Update desktop city selector
    const desktopCurrentCity = document.querySelector(".header__current-city")
    const desktopMiniCity = document.querySelector(".header__mini-city-name")
    if (desktopCurrentCity) desktopCurrentCity.textContent = city
    if (desktopMiniCity) desktopMiniCity.textContent = city

    // Update desktop city options
    document.querySelectorAll(".header__city-option").forEach((opt) => {
      opt.classList.toggle("active", opt.textContent.trim() === city)
    })

    // Trigger city change
    onCityChange(city)

    // Update mobile schools slider
    currentMobileSchoolIndex = 0
    updateMobileSchoolsSlider(city)

    // Close dropdown
    cityDropdown.classList.remove("active")
    cityBtn.classList.remove("active")
    if (cityInput) cityInput.value = ""
  })
}

function initMobileSubmenus() {
  const toggles = document.querySelectorAll(".header__mobile-submenu-toggle")

  toggles.forEach((toggle) => {
    toggle.addEventListener("click", (e) => {
      e.preventDefault()
      const menuItem = toggle.closest(".header__mobile-menu-item")

      // Close other open submenus
      document.querySelectorAll(".header__mobile-menu-item--open").forEach((item) => {
        if (item !== menuItem) {
          item.classList.remove("header__mobile-menu-item--open")
        }
      })

      // Toggle current submenu
      menuItem.classList.toggle("header__mobile-menu-item--open")
    })
  })
}

function initMobileSchoolsSlider() {
  updateMobileSchoolsSlider("Екатеринбург")
}

function updateMobileSchoolsSlider(city) {
  const schools = schoolsData[city] || []
  const slider = document.querySelector(".header__mobile-schools-slider")
  const dots = document.querySelector(".header__mobile-schools-dots")
  const countEl = document.querySelector(".header__mobile-schools-count")

  if (countEl) {
    countEl.textContent = `(${schools.length})`
  }

  if (slider) {
    slider.innerHTML = schools
      .map(
        (school, index) => `
      <div class="header__mobile-school-card ${index === currentMobileSchoolIndex ? "header__mobile-school-card active" : ""}" data-index="${index}">
        <div class="header__mobile-school-address">${school.address}</div>
        <a href="tel:${school.phone.replace(/\s/g, "")}" class="header__mobile-school-phone">${school.phone}</a>
        <div class="header__mobile-school-hours">${school.hours}</div>
      </div>
    `,
      )
      .join("")
  }

  if (dots && schools.length > 1) {
    dots.innerHTML = schools
      .map(
        (_, index) => `
      <button class="header__mobile-schools-dot ${index === currentMobileSchoolIndex ? "header__mobile-schools-dot active" : ""}" data-index="${index}" aria-label="Школа ${index + 1}"></button>
    `,
      )
      .join("")

    // Add click handlers to dots
    dots.querySelectorAll(".header__mobile-schools-dot").forEach((dot) => {
      dot.addEventListener("click", () => {
        currentMobileSchoolIndex = Number.parseInt(dot.dataset.index, 10)
        updateMobileSchoolsDisplay()
      })
    })
  } else if (dots) {
    dots.innerHTML = ""
  }
}

function updateMobileSchoolsDisplay() {
  const cards = document.querySelectorAll(".header__mobile-school-card")
  const dots = document.querySelectorAll(".header__mobile-schools-dot")

  cards.forEach((card, index) => {
    card.classList.toggle("active", index === currentMobileSchoolIndex)
  })

  dots.forEach((dot, index) => {
    dot.classList.toggle("active", index === currentMobileSchoolIndex)
  })
}

function startMobileSchoolsRotation() {
  const currentCity = document.querySelector(".header__mobile-current-city")?.textContent || "Екатеринбург"
  const schools = schoolsData[currentCity] || []

  if (schools.length <= 1) return

  mobileAutoRotateInterval = setInterval(() => {
    currentMobileSchoolIndex = (currentMobileSchoolIndex + 1) % schools.length
    updateMobileSchoolsDisplay()
  }, MOBILE_ROTATE_INTERVAL)
}

function stopMobileSchoolsRotation() {
  if (mobileAutoRotateInterval) {
    clearInterval(mobileAutoRotateInterval)
    mobileAutoRotateInterval = null
  }
}

function getSchoolsWord(count) {
  const lastDigit = count % 10
  const lastTwoDigits = count % 100

  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
    return "филиалов"
  }

  if (lastDigit === 1) {
    return "филиал"
  }

  if (lastDigit >= 2 && lastDigit <= 4) {
    return "филиала"
  }

  return "филиалов"
}
